var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramFocusTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 28,
    viewBox: "0 0 178 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_518_44549)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_518_44549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3364 28L0.904289 19.9602L10.2765 13.9975L0.904289 8.0398L13.3364 0L15.226 2.91804L7.34323 8.01447L16.7559 13.9975L7.34323 19.9855L15.226 25.0769L13.3364 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6761 28L11.239 19.9602L20.6163 13.9975L11.239 8.0398L23.6761 0L25.5607 2.91804L17.683 8.01447L27.0957 13.9975L17.683 19.9855L25.5607 25.0769L23.6761 28Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_518_44549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5584 1.6084H55.3882V26.3848H59.5584V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9239 1.6084H66.7537V26.3848H70.9239V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5798 11.2157L56.8021 15.2344L58.1487 19.1812L69.9265 15.1625L68.5798 11.2157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6487 1.6416H36V5.81181H50.6487V1.6416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4128 3.72656H41.2426V26.3582H45.4128V3.72656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.818 28L73.8099 13.1461L82.9844 0L86.4 2.38298L78.9399 13.0733L88.1674 25.5177L84.818 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4927 11.0283H76.3783V15.1985H86.4927V11.0283Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_518_44549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.852 28L129.756 13.1476L139 0L142.443 2.38143L134.929 13.0746L144.227 25.5191L140.852 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.365 27.0649H96.1674V5.11465L106.408 0.935547L108.005 4.78961L100.365 7.90735V27.0649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.341 12.0356L97.4026 16.0537L99.1347 19.8484L108.073 15.8302L106.341 12.0356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.141 27.038L109.99 14.3481L119.054 0.955078L128.579 13.7445L119.141 27.038ZM114.87 14.2486L119.128 20.3382L123.653 13.7511L119.215 8.19223L114.87 14.2552V14.2486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.843 27.3164L165.256 24.0262L171.198 19.4291L163.732 10.401L173.424 0.563477L176.425 3.48222L169.367 10.6464L177.167 20.0859L167.843 27.3164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.803 27.1774V0.736293H152.001V20.9088L157.649 18.5539L157.389 0.762827L161.586 0.703125L161.887 21.3068L147.803 27.1774Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_518_44549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_518_44549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.1914,
    height: 28,
    fill: "white",
    transform: "translate(0.904289)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_518_44549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.1674,
    height: 28,
    fill: "white",
    transform: "translate(36)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_518_44549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 28,
    fill: "white",
    transform: "translate(96.1674)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramFocusTab);
export default __webpack_public_path__ + "static/media/programFocusTab.65d13e5e27b25a37c59dddd26d49e9f5.svg";
export { ForwardRef as ReactComponent };